import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { playerDisplayName } from '../game/presentation';
import { humanizeFirebaseError } from '../hooks/useGame';
import { createGameDocument } from '../services/gameRepository';
import HowTo from './play/HowTo';
import MuteButton from './play/MuteButton';

const Home: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [howTo, setHowTo] = useState(false);
  const name = playerDisplayName(currentUser);

  const handleCreate = async () => {
    if (!currentUser) {
      navigate('/login');
      return;
    }
    if (!currentUser.displayName?.trim()) {
      navigate('/start-game');
      return;
    }
    try {
      setCreating(true);
      setError('');
      const gameId = await createGameDocument(currentUser.uid, name);
      navigate(`/game-lobby/${gameId}`);
    } catch (err) {
      setError(humanizeFirebaseError(err));
      setCreating(false);
    }
  };

  return (
    <div className="ss-landing">
      <div className="ss-landing-hero">
        <div className="ss-landing-top">
          <MuteButton />
        </div>
        <p className="ss-kicker">Family word game</p>
        <h1 className="ss-brand">
          Spin <em>&amp;</em> Solve
        </h1>
        <p className="ss-landing-copy">
          Spin for cash, tap letters, and solve the puzzle. Same room or different couches — you just need a code.
        </p>

        {error && <div className="ss-error">{error}</div>}

        {currentUser ? (
          <>
            <p className="ss-who">Signed in as {name}</p>
            <button type="button" className="ss-btn ss-btn-primary" onClick={handleCreate} disabled={creating}>
              {creating ? 'Creating room' : 'Create a game'}
            </button>
            <button type="button" className="ss-btn ss-btn-ghost" onClick={() => navigate('/join-game')}>
              Join with a code
            </button>
            <button type="button" className="ss-btn ss-btn-ghost" onClick={() => setHowTo(true)}>
              How to play
            </button>
            <Link to="/profile" className="ss-inline-link">
              Profile
            </Link>
          </>
        ) : (
          <>
            <p className="ss-who">Sign in to host or join a room.</p>
            <button type="button" className="ss-btn ss-btn-primary" onClick={() => navigate('/login')}>
              Log in
            </button>
            <button type="button" className="ss-btn ss-btn-ghost" onClick={() => navigate('/signup')}>
              Create an account
            </button>
            <button type="button" className="ss-btn ss-btn-ghost" onClick={() => setHowTo(true)}>
              How to play
            </button>
          </>
        )}
      </div>
      <HowTo auto open={howTo} onClose={() => setHowTo(false)} />
    </div>
  );
};

export default Home;
